/** Decode JWT payload (no signature verification — client-side enrichment only). */
export function parseJwtPayload(accessToken) {
  if (!accessToken || typeof accessToken !== "string") return {};
  try {
    const segment = accessToken.split(".")[1];
    if (!segment) return {};
    const base64 = segment.replace(/-/g, "+").replace(/_/g, "/");
    const json = atob(base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "="));
    return JSON.parse(json);
  } catch {
    return {};
  }
}

/** Align SSO / login payloads with fields the ATS app reads from `userData`. */
export function normalizeAuthSession(userDatas) {
  if (!userDatas?.accessToken) return null;

  const claims = parseJwtPayload(userDatas.accessToken);
  const rawUserId =
    userDatas.userId ?? claims.userId ?? claims.sub ?? claims.nameidentifier;
  const userId =
    rawUserId != null && rawUserId !== ""
      ? Number(rawUserId) || rawUserId
      : rawUserId;
  const rawUserTypeId =
    userDatas.userTypeId ?? claims.UserTypeId ?? claims.userTypeId;
  const userTypeId =
    rawUserTypeId != null && rawUserTypeId !== ""
      ? Number(rawUserTypeId) || rawUserTypeId
      : rawUserTypeId;

  return {
    ...userDatas,
    accessToken: userDatas.accessToken,
    userId,
    id: userDatas.id ?? userId,
    userName: userDatas.userName ?? claims.name ?? userDatas.name,
    userTypeId,
    sessionId: userDatas.sessionId ?? claims.sessionId,
    expiresAt: userDatas.expiresAt,
    tokenType: userDatas.tokenType ?? "Bearer",
  };
}

/** Extract auth result from API envelope or raw body. */
export function extractAuthResultFromExchangeResponse(response) {
  if (!response || typeof response !== "object") return null;

  if (response.success === false) return null;

  const candidates = [
    response.data,
    response.Data,
    response,
  ].filter((item) => item && typeof item === "object");

  for (const item of candidates) {
    if (item.accessToken) {
      return normalizeAuthSession(item);
    }
    if (item.data?.accessToken) {
      return normalizeAuthSession(item.data);
    }
  }

  return null;
}
